export const isDefined = value => typeof value !== 'undefined';

export const getURL = (dataset, offset = 0, tableRowCount = 20, sort = '') => {
  const {
    category = '',
    site = '',
    fieldset = '',
    origin = 'straightforward-niche',
  } = dataset;
  const baseUrl = window.location.origin || '';
  if (category === '' || site === '' || fieldset === '') {
    return;
  }

  const params = [
    `${baseUrl}/wordpress/wp-admin/admin-ajax.php?action=get_paginated_table_ajax`,
    'template=comparison',
    `site=${site}`,
    `category=${category}`,
    `origin=${origin}`,
    `fieldset=${fieldset}`,
    `offset=${offset}`,
    `page_size=${tableRowCount}`,
  ];

  if (sort !== '') {
    params.push(`sort=${sort}`);
  }

  return params.join('&');
};

export const initiateTableLoading = (table, isLoading = true) => {
  if (table && table.classList) {
    if (isLoading) {
      table.classList.add('comparison-table--loading');
    } else {
      table.classList.remove('comparison-table--loading');
    }
  }
};

export const updateNavButtonsState = (elements, offsetValues, classnames) => {
  const { prevButton, nextButton } = elements;
  const { prevButton: prevButtonClassName, nextButton: nextButtonClassName } = classnames;
  const { prevOffset, nextOffset, offset } = offsetValues;

  if (prevButton && nextButton &&
    isDefined(prevOffset) && isDefined(nextOffset) && isDefined(offset)
  ) {
    if (prevButton.classList && nextButton.classList) {
      prevButton.classList.remove(prevButtonClassName);
      nextButton.classList.remove(nextButtonClassName);

      if (Number(offset) === 0) {
        prevButton.classList.add(prevButtonClassName);
      }

      if (nextOffset === null) {
        nextButton.classList.add(nextButtonClassName);
      }

      prevButton.dataset.offset = prevOffset;
      nextButton.dataset.offset = nextOffset;
    }
  }
};

export const updateNumberButtonsState = (activeButtonClassname, elements) => {
  const { prevActiveButton, activeButton } = elements;

  if (prevActiveButton && prevActiveButton.classList) {
    prevActiveButton.classList.remove(activeButtonClassname);
  }

  if (activeButton && activeButton.classList) {
    activeButton.classList.add(activeButtonClassname);
  }
};

export const isPaginationEnabled = (paginationContainer, tableRowCount, defaultOffset) =>
  paginationContainer && isDefined(tableRowCount) && isDefined(defaultOffset);

export const fetchPaginatedTable = url => fetch(url).then(response => response.json());

export const reselectCompareCheckboxes = (compareForm) => {
  if (compareForm && compareForm.name === 'compareForm') {
    const event = new CustomEvent('reselect-compare-checkboxes');
    compareForm.dispatchEvent(event);
  }
};
